import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({ name: '', email: '', subject: '', message: '' });
    alert('Thank you for your message! We\'ll get back to you soon.');
  };

  return (
    <div className="bg-ink text-white font-sans">
      {/* Hero Section */}
      <section className="panel-surface text-white section-padding">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-display font-bold mb-6">
            Contact IBT Sports
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Have questions about our services? Need technical support? 
            We're here to help with all your sports streaming needs.
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-display font-bold text-white mb-8">
                Send us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-200 mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 rounded-lg bg-slate-card text-white placeholder-gray-400 border border-line focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200"
                      placeholder="Enter your full name"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-200 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 rounded-lg bg-slate-card text-white placeholder-gray-400 border border-line focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200"
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-semibold text-gray-200 mb-2">
                    Subject *
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg bg-slate-card text-white border border-line focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200"
                  >
                    <option value="">Select a subject</option>
                    <option value="technical-support">Technical Support</option>
                    <option value="billing">Billing & Subscriptions</option>
                    <option value="content">Content & Licensing</option>
                    <option value="partnership">Partnership Opportunities</option>
                    <option value="feedback">Feedback & Suggestions</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-200 mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-4 py-3 rounded-lg bg-slate-card text-white placeholder-gray-400 border border-line focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>

                <button type="submit" className="btn-pill-primary w-full">
                  Send Message
                </button>
              </form>

              <div className="mt-8 p-6 panel-surface">
                <h3 className="text-lg font-semibold text-white mb-3">
                  Need Immediate Help?
                </h3>
                <p className="text-gray-300 mb-4">
                  For urgent technical issues or account problems, contact our 24/7 support team:
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a href="tel:+1-800-IBT-SPORT" className="btn-pill-secondary text-center">
                    📞 Call Support
                  </a>
                  <a href="#" className="btn-pill-secondary text-center">
                    💬 Live Chat
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <h2 className="text-3xl font-display font-bold text-white mb-8">
                Get in Touch
              </h2>
              
              <div className="space-y-8">
                {/* Quick Contact */}
                <div className="bg-gradient-to-br from-primary to-accent-warm rounded-2xl p-8 text-white shadow-glow-primary">
                  <h3 className="text-xl font-bold mb-6">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <svg className="w-6 h-6 mr-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                      <div>
                        <div className="font-semibold">Phone Support</div>
                        <div className="text-white/90">+1 (800) IBT-SPORT</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center">
                      <svg className="w-6 h-6 mr-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      <div>
                        <div className="font-semibold">Email Support</div>
                        <div className="text-white/90">support@ibtsports.com</div>
                      </div>
                    </div>
                    
                    <div className="flex items-center">
                      <svg className="w-6 h-6 mr-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="font-semibold">Support Hours</div>
                        <div className="text-white/90">24/7 Available</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Business Contact */}
                <div className="panel-surface p-8">
                  <h3 className="text-xl font-bold text-white mb-6">Business Inquiries</h3>
                  <div className="space-y-4">
                    <div>
                      <div className="font-semibold text-white">Partnership & Licensing</div>
                      <div className="text-gray-300">partnerships@ibtsports.com</div>
                    </div>
                    
                    <div>
                      <div className="font-semibold text-white">Media & Press</div>
                      <div className="text-gray-300">press@ibtsports.com</div>
                    </div>
                    
                    <div>
                      <div className="font-semibold text-white">Career Opportunities</div>
                      <div className="text-gray-300">careers@ibtsports.com</div>
                    </div>
                    
                    <div>
                      <div className="font-semibold text-white">Investor Relations</div>
                      <div className="text-gray-300">investors@ibtsports.com</div>
                    </div>
                  </div>
                </div>

                {/* Social Media */}
                <div className="panel-surface rounded-2xl p-8">
                  <h3 className="text-xl font-bold text-white mb-6">Follow Us</h3>
                  <div className="flex space-x-4">
                    <a href="#" className="w-12 h-12 rounded-full flex items-center justify-center text-white border border-line hover:border-primary transition duration-200">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                      </svg>
                    </a>
                    <a href="#" className="w-12 h-12 rounded-full flex items-center justify-center text-white border border-line hover:border-primary transition duration-200">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </a>
                    <a href="#" className="w-12 h-12 rounded-full flex items-center justify-center text-white border border-line hover:border-primary transition duration-200">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </a>
                    <a href="#" className="w-12 h-12 rounded-full flex items-center justify-center text-white border border-line hover:border-primary transition duration-200">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.097.118.112.221.083.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.748-1.378 0 0-.599 2.282-.744 2.840-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24.001 12.017 24.001c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-display font-bold text-white mb-4">
              Our Global Offices
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto font-sans">
              With offices in major markets across America and Europe, 
              we're always close to our customers and partners.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* US Headquarters */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent-warm/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary to-accent-warm rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white font-display">US Headquarters</h3>
                      <div className="badge-official text-xs">Primary Office</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-primary font-display">NYC</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">New York</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">24/7 Support</span>
                  <span className="badge">Licensing</span>
                  <span className="badge">Partnerships</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg className="w-5 h-5 text-primary mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">123 Sports Avenue, Suite 500</div>
                      <div>New York, NY 10001</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">+1 (212) 555-0123</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">Mon-Fri: 9 AM - 6 PM EST</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* West Coast Office */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-warm/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-accent-warm to-primary rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white font-display">West Coast Office</h3>
                      <div className="badge-official text-xs">Technology Hub</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-accent-warm font-display">LA</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">Los Angeles</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">Innovation</span>
                  <span className="badge">R&D Center</span>
                  <span className="badge">Tech Support</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg className="w-5 h-5 text-accent-warm mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">456 Innovation Drive</div>
                      <div>Los Angeles, CA 90028</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-accent-warm mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">+1 (310) 555-0456</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-accent-warm mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">Mon-Fri: 9 AM - 6 PM PST</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* European Headquarters */}
            <div className="card-glass card-hover group relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-success/10 to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Header */}
              <div className="p-8 border-b border-line">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-gradient-to-br from-accent-success to-primary rounded-xl flex items-center justify-center mr-4 shadow-glow-primary">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white font-display">European HQ</h3>
                      <div className="badge-official text-xs">EU Operations</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-accent-success font-display">LON</div>
                    <div className="text-xs text-gray-400 uppercase tracking-wider">London</div>
                  </div>
                </div>
                
                {/* Authority Badges */}
                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="badge">EU Market</span>
                  <span className="badge">Multi-Language</span>
                  <span className="badge">Local Content</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="space-y-4">
                  <div className="flex items-start">
                    <svg className="w-5 h-5 text-accent-success mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">789 Canary Wharf</div>
                      <div>London E14 5AB, UK</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-accent-success mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">+44 20 7946 0789</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-accent-success mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                    <div className="text-sm text-gray-300 font-sans">
                      <div className="font-semibold text-white">Mon-Fri: 9 AM - 5 PM GMT</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <div className="card-glass rounded-xl p-8 max-w-2xl mx-auto">
              <h3 className="text-xl font-semibold text-white mb-4 font-display">
                Looking for a Career at IBT Sports?
              </h3>
              <p className="text-gray-300 mb-6 font-sans">
                Join our growing team of sports technology experts and help shape the future of sports streaming.
              </p>
              <button className="btn-pill-primary font-display">
                View Open Positions
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 